import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from './types/close';
import ImageIcon from './types/image';
import MailIcon from './types/mail';
import CopyIcon from './types/copy';
import ChevRightIcon from './types/chevRight';
import ArticlesNotFoundIcon from './types/articlesNotFound';
import ReceiptNotFoundIcon from './types/receiptNotFound';
import WarningIcon from './types/warning';
import MenuIcon from './types/menu';
import BackIcon from './types/back';
import InfoIcon from './types/info';
import DownloadIcon from './types/download';
import MuteIcon from './types/mute';
import PauseIcon from './types/pause';
import PlayIcon from './types/play';
import SoundIcon from './types/sound';
import CheckIcon from './types/check';
import ArrowRight from './types/arrowRight';
import ArrowLeft from './types/arrowLeft';
import Box from './types/box';
import Stairs from './types/stairs';
import StairsMech from './types/stairsMech';
import FittingRooms from './types/fittingRooms';
import Elevator from './types/elevator';
import CheckOut from './types/checkOut';
import Entry from './types/entry';

export default function Icon({ icon, color }) {
  switch (icon) {
    case 'articlesNotFound':
      return <ArticlesNotFoundIcon color={color} />;
    case 'back':
      return <BackIcon color={color} />;
    case 'chevronRight':
      return <ChevRightIcon color={color} />;
    case 'close':
      return <CloseIcon color={color} />;
    case 'copy':
      return <CopyIcon color={color} />;
    case 'download':
      return <DownloadIcon color={color} />;
    case 'image':
      return <ImageIcon color={color} />;
    case 'info':
      return <InfoIcon color={color} />;
    case 'mail':
      return <MailIcon color={color} />;
    case 'menu':
      return <MenuIcon color={color} />;
    case 'mute':
      return <MuteIcon color={color} />;
    case 'pause':
      return <PauseIcon color={color} />;
    case 'play':
      return <PlayIcon color={color} />;
    case 'receiptNotFound':
      return <ReceiptNotFoundIcon color={color} />;
    case 'sound':
      return <SoundIcon color={color} />;
    case 'warning':
      return <WarningIcon color={color} />;
    case 'check':
      return <CheckIcon color={color} />;
    case 'arrow_r':
      return <ArrowRight />;
    case 'arrow_l':
      return <ArrowLeft />;
    case 'box':
      return <Box />;
    case 'stairs':
      return <Stairs />;
    case 'stairsMech':
      return <StairsMech />;
    case 'fitting':
      return <FittingRooms />;
    case 'elevator':
      return <Elevator />;
    case 'checkOut':
      return <CheckOut />;
    case 'entry':
      return <Entry />;
    default:
      return <i>:( No icon found</i>;
  }
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
};

Icon.defaultProps = {
  icon: 'close',
  color: '#000000',
};
